<script>
import Common from '@/components/Common'
export default {
  mixins: [ Common ],
  data: () => ({
    userid: '',
    pass: '',
    msg: '',
    alert: false
  }),
  methods: {
    login () {
      var self = this
      this.$axios.post(this.url + 'getAuth.php', JSON.stringify({
        userid: this.userid,
        pass: this.pass
      })).then(function (res) {
        if (res.data.length === 0) {
          self.msg = 'IDまたはパスワードが間違っています。'
          self.alert = true
        } else {
          self.$store.dispatch('doUpdate', res.data)
          self.$router.push('/top')
        }
      })
    },
    logout () {
      this.$store.dispatch('doUpdate', '')
      this.$router.push('/')
    },
    admin () {
      if ("admin" == this.$store.getters.auth.role) {
        return true
      }
      return false
    }
  }
}
</script>
